import { render } from "./VideoGallery.vue?vue&type=template&id=60778f50&scoped=true"
import script from "./VideoGallery.vue?vue&type=script&lang=js"
export * from "./VideoGallery.vue?vue&type=script&lang=js"

import "./VideoGallery.vue?vue&type=style&index=0&id=60778f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60778f50"]])

export default __exports__